import React, { useState } from 'react';

const NewVersionBanner = () => {
    const [isVisible, setIsVisible] = useState(true);

    if (!isVisible) return null;

    const bannerStyle = {
        background: 'linear-gradient(135deg, #00A76F 0%, #007B55 100%)',
        padding: '14px 20px',
        textAlign: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '15px',
        flexWrap: 'wrap',
    };

    const textStyle = {
        color: 'white',
        fontSize: '15px',
        fontWeight: '500',
        margin: 0,
    };

    const buttonStyle = {
        background: 'white',
        color: '#007B55',
        border: 'none',
        padding: '8px 20px',
        borderRadius: '6px',
        fontWeight: '600',
        fontSize: '14px',
        cursor: 'pointer',
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    };

    const closeButtonStyle = {
        background: 'transparent',
        border: 'none',
        color: 'white',
        fontSize: '20px',
        cursor: 'pointer',
        padding: '0 10px',
        opacity: 0.8,
        position: 'absolute',
        right: '15px',
    };

    return (
        <div style={bannerStyle}>
            <span style={{ fontSize: '20px' }}>🚀</span>
            <p style={textStyle}>
                <strong>Nouvelle version du CRM disponible !</strong> Interface moderne et améliorée.
            </p>
            <a 
                href="https://v2.crm.iweb-marketing.com" 
                style={buttonStyle}
                onMouseOver={(e) => {
                    e.target.style.transform = 'scale(1.05)';
                    e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                }}
                onMouseOut={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                }}
            >
                Essayer maintenant →
            </a>
            <button 
                style={closeButtonStyle} 
                onClick={() => setIsVisible(false)}
                title="Fermer"
            >
                ×
            </button>
        </div>
    );
};

export default NewVersionBanner;

